import * as constants from "../assets/constants";
import {baseApi} from "./BaseApi";


class PartnersProductsApi extends baseApi {

    getParamsList = async ({group_id, params} = {}) => {
        return await this.post('?app=partnersproducts&act=getParamsList', {
            group_id: group_id == null ? '' : group_id,
            params: JSON.stringify(params || []),
        })
    }

}

export {PartnersProductsApi}
export default new PartnersProductsApi(constants.DEBUG ? constants.base_url_stage : constants.base_url_prod);
